import React, { memo, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Box } from '@mui/material';
import {
  ensureGuestRegistrationCardStyles,
  renderGuestRegistrationCardMarkup,
} from './guestRegistrationCardHtml';

const PAGE_WIDTH_PX = 794;
const PAGE_HEIGHT_PX = 1123;

function GuestRegistrationCard({ data }) {
  const wrapRef = useRef(null);
  const [scale, setScale] = useState(1);
  const markup = useMemo(() => renderGuestRegistrationCardMarkup(data), [data]);

  useLayoutEffect(() => {
    ensureGuestRegistrationCardStyles();
    const wrap = wrapRef.current;
    if (!wrap) return undefined;

    const updateScale = () => {
      const availW = Math.max(wrap.clientWidth - 8, 0);
      const availH = Math.max(wrap.clientHeight - 8, 0);
      if (!availW || !availH) return;
      setScale(Math.min(availW / PAGE_WIDTH_PX, availH / PAGE_HEIGHT_PX, 1));
    };

    updateScale();
    const observer = new ResizeObserver(updateScale);
    observer.observe(wrap);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      ref={wrapRef}
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: '#d8e2dc',
        borderRadius: 1.5,
        colorScheme: 'only light',
      }}
    >
      <div
        style={{
          width: PAGE_WIDTH_PX * scale,
          height: PAGE_HEIGHT_PX * scale,
          position: 'relative',
          flexShrink: 0,
        }}
      >
        <div
          className="grc-page"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: PAGE_WIDTH_PX,
            height: PAGE_HEIGHT_PX,
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
            boxShadow: '0 8px 24px rgba(22, 51, 45, 0.12)',
            colorScheme: 'only light',
            color: '#16332d',
            background: '#fffdf8',
          }}
          dangerouslySetInnerHTML={{ __html: markup }}
        />
      </div>
    </Box>
  );
}

export default memo(GuestRegistrationCard);
